export class User {
    adpUserId: string;
    emailAddress: string;
    clientId: string;
    userPolicies: UserPolicy[];
    createdOn: Date;
    modifiedOn: Date;
}

export class UserPolicy {
    policyNumber: string;
    dealerCode: string;
}
